document.addEventListener('DOMContentLoaded', () => {
    // Esperar a que GSAP y ScrollTrigger estén disponibles
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        console.warn('GSAP or ScrollTrigger not loaded');
        return;
    }

    gsap.registerPlugin(ScrollTrigger);

    const timelineBlocks = document.querySelectorAll('.timeline-block');

    timelineBlocks.forEach((block) => {
        const progressBar = block.querySelector('.timeline-block__progress-bar');
        const markers = block.querySelectorAll('.marker');
        const connectors = block.querySelectorAll('.connector');

        // Animación de la barra de progreso
        if (progressBar) {
            // Obtener altura total de la barra
            const totalHeight = progressBar.offsetHeight;
            
            gsap.fromTo(progressBar,
                {
                    height: 0
                },
                {
                    height: totalHeight,
                    ease: 'none',
                    scrollTrigger: {
                        trigger: block,
                        start: 'top center',
                        end: 'bottom center',
                        scrub: 1,
                        onUpdate: (self) => {
                            // Mostrar ::before cuando empiece
                            if (self.progress > 0.03) {
                                progressBar.classList.add('timeline-started');
                            } else {
                                progressBar.classList.remove('timeline-started');
                            }
                            
                            // Mostrar ::after cuando llegue al 97%
                            if (self.progress >= 0.97) {
                                progressBar.classList.add('timeline-complete');
                            } else {
                                progressBar.classList.remove('timeline-complete');
                            }
                        },
                        // markers: true, // Descomenta para debug
                    }
                }
            );
        }

        // Animación de los marcadores y conectores sincronizada con la barra de progreso
        markers.forEach((marker, index) => {
            const content = marker.querySelector('.marker__content');
            const connector = marker.querySelector('.connector');
            const column = marker.getAttribute('data-column');
            
            // Determinar dirección según columna
            const xOffset = column === '1' ? -50 : 50;

            // Estado inicial del conector (oculto)
            if (connector) {
                gsap.set(connector, {
                    scaleX: 0,
                    transformOrigin: 'left center'
                });
            }

            // Crear timeline para sincronizar animaciones
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: marker,
                    start: 'top center',
                    end: 'top center',
                    onEnter: () => {
                        // Animar contenido
                        gsap.to(content, {
                            opacity: 1,
                            x: 0,
                            duration: 0.8,
                            ease: 'power2.out',
                        });
                        
                        // Animar conector después del contenido
                        if (connector) {
                            gsap.to(connector, {
                                scaleX: 1,
                                duration: 0.6,
                                delay: 0.3,
                                ease: 'power2.out',
                            });
                        }
                    },
                    onLeaveBack: () => {
                        // Revertir animación al hacer scroll back
                        gsap.to(content, {
                            opacity: 0,
                            x: xOffset,
                            duration: 0.8,
                            ease: 'power2.in',
                        });
                        
                        if (connector) {
                            gsap.to(connector, {
                                scaleX: 0,
                                duration: 0.6,
                                ease: 'power2.in',
                            });
                        }
                    },
                    // markers: true, // Descomenta para debug
                }
            });

            // Estado inicial del contenido
            gsap.set(content, {
                opacity: 0,
                x: xOffset
            });
        });
    });
});
